import { z } from 'zod';

// Customer story schema for listing/card view (minimal fields)
export const ExpertCustomerStoryCardSchema = z.object({
    title: z.string().optional().nullable().default('').transform((val) => val || ''),
    slug: z.string(),
    images: z.array(z.string()),
});

export type ShopexpertCustomerStoryCard = z.infer<typeof ExpertCustomerStoryCardSchema>;

